import { fetchDatalakeFile } from '@/utils/datalake';

const downloadFileFromDatalake = async (fileId: string) => {
  return fetchDatalakeFile({ fileId }, 'blob');
};

export default downloadFileFromDatalake;
